import { render, staticRenderFns } from "./wine-customer-sales.vue?vue&type=template&id=61a60d27&scoped=true&"
import script from "./wine-customer-sales.vue?vue&type=script&lang=js&"
export * from "./wine-customer-sales.vue?vue&type=script&lang=js&"
import style0 from "./wine-customer-sales.vue?vue&type=style&index=0&id=61a60d27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a60d27",
  null
  
)

export default component.exports